/**
 * @generated SignedSource<<f7ecce2e2a15e327a05065e415859c60>>
 * @relayHash c0a8f920bcb634ef1fa700a213774329
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b5649bc358983fe4385ab00b61e3b4e7f364bc4213918a6331132682647b49b4

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceTransactionAccountEndOfTrialQuery$variables = {
  cloudId: string;
  productKey: string;
};
export type ConfluenceTransactionAccountEndOfTrialQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly transactionAccount: {
          readonly isBillToPresent: boolean | null;
          readonly isCurrentUserBillingAdmin: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
};
export type ConfluenceTransactionAccountEndOfTrialQuery = {
  response: ConfluenceTransactionAccountEndOfTrialQuery$data;
  variables: ConfluenceTransactionAccountEndOfTrialQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
},
v4 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConfluenceTransactionAccountEndOfTrialQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluenceTransactionAccountEndOfTrialQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "c0a8f920bcb634ef1fa700a213774329",
    "id": "b5649bc358983fe4385ab00b61e3b4e7f364bc4213918a6331132682647b49b4",
    "metadata": {},
    "name": "ConfluenceTransactionAccountEndOfTrialQuery",
    "operationKind": "query",
    "text": "query ConfluenceTransactionAccountEndOfTrialQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,transactionAccount{__typename,isBillToPresent,isCurrentUserBillingAdmin,...on Node{__isNode:__typename,id}},id}}}}"
  }
};
})();

(node as any).hash = "6ae456392533297b4cacbb695ac5f76d";

export default node;
